import React from 'react';
import * as Styles from './Guides.styles';
import { Guide } from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';
import Snappy from '@/media/billing/snappy-with-shadow.svg';
import { useSelector } from 'react-redux';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ENABLE_LOGO_BUILDER } from '@/config/GrowthBook/constants';

const Guides = () => {
  const { template: templateLocale } = useLocale();
  const view = useResize();
  const isMobile = view.width < 960;
  const enableLogoBuilder = useFeatureIsOn(ENABLE_LOGO_BUILDER);
  const { available: logoBuilderAvailable } = useSelector(state => state.logoBuilder);

  const LogoBuilderGuideContent = () => (
    <Styles.LogoBuilderGuide>
      <Styles.GuideTexts>
        <Styles.GuideTitle data-testid="title">
          {templateLocale.logoBuilderGuide.title}
        </Styles.GuideTitle>
        <Styles.GuideDescription data-testid="description">
          {templateLocale.logoBuilderGuide.description}
        </Styles.GuideDescription>
      </Styles.GuideTexts>
      <Styles.Image src={Snappy} />
    </Styles.LogoBuilderGuide>
  );

  const logoBuilderGuideSteps = [{
    popover: {
      $left: 211, $top: 445, content: LogoBuilderGuideContent(), pointer: 'leftBottom', $maxwidth: 285,
    },
  }];

  if (logoBuilderAvailable && enableLogoBuilder && isBRServer && !isMobile) {
    return (
      <>
        <Styles.GuideShadow />
        <Guide
          steps={logoBuilderGuideSteps}
        />
      </>
    );
  }

  return <></>;
};

export default Guides;
